export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/account-icon.svg?c65a55ed065c4c7aeff32a310e999062";